export { default as Sample } from './page'


// WEBPACK FOOTER //
// ./src/pages/Sample/index.js